import { render, staticRenderFns } from "./TFSortableImages.vue?vue&type=template&id=2b3f206c&"
import script from "./TFSortableImages.vue?vue&type=script&lang=js&"
export * from "./TFSortableImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/tablefever-websites/src/vue-apps/manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3f206c')) {
      api.createRecord('2b3f206c', component.options)
    } else {
      api.reload('2b3f206c', component.options)
    }
    module.hot.accept("./TFSortableImages.vue?vue&type=template&id=2b3f206c&", function () {
      api.rerender('2b3f206c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/custom-form/TFSortableImages.vue"
export default component.exports